import { TReduxActions } from '../../types/redux';
import { IGk } from '../../store/pik_data/gks';
import { EGksActionTypes } from '../../actions/gks';

export function gksReducer(state: IGk[] = [], action: TReduxActions) {
  if (action.type === EGksActionTypes.SetGks) {
    return [...action.payload];
  }

  return state;
}
